<template>
  <v-container fluid class="pa-4">
    <v-layout row wrap>
      <v-flex cols="12">
        <!-- Main Card -->
        <v-card v-if="user">
          <v-card-title class="text-h5 font-weight-bold">
            <v-icon left color="primary">mdi-account-circle</v-icon>
            <div>User Details</div>
          </v-card-title>
          <v-card-text class="pt-6">
            <v-layout row wrap>
              <v-flex xs12>
                <v-list two-line class="bg-transparent">
                  <!-- Name -->
                  <v-list-tile class="px-0">
                    <v-icon color="blue-grey" class="mr-4">mdi-account</v-icon>
                    <span class="font-weight-bold mr-2">Name:</span>
                    <div>
                      <span class="text-h6">{{ user.name || "—" }}</span>
                    </div>
                  </v-list-tile>

                  <v-divider></v-divider>

                  <!-- Email -->
                  <v-list-tile class="px-0">
                    <v-icon color="blue-grey" class="mr-4">mdi-email</v-icon>
                    <span class="font-weight-bold mr-2">Email:</span>
                    <div>
                      <span class="text-h6">{{ user.emailId || "—" }}</span>
                    </div>
                  </v-list-tile>

                  <v-divider></v-divider>

                  <!-- User ID -->
                  <v-list-tile class="px-0">
                    <v-icon color="blue-grey" class="mr-4">mdi-account</v-icon>
                    <span class="font-weight-bold mr-2">User ID:</span>
                    <div>
                      <span class="text-h6">{{ user.id || "—" }}</span>
                    </div>
                  </v-list-tile>

                  <v-divider></v-divider>

                  <!-- Phone -->
                  <v-list-tile class="px-0">
                    <v-icon color="blue-grey" class="mr-4">mdi-phone</v-icon>
                    <span class="font-weight-bold mr-2"
                      >Phone in ManageEngine:</span
                    >
                    <div>
                      <span class="text-h6">{{ user.phone || "—" }}</span>
                    </div>
                  </v-list-tile>

                  <v-divider></v-divider>

                  <!-- Phone Mapped -->
                  <v-list-tile class="px-0">
                    <v-icon color="blue-grey" class="mr-4">mdi-phone</v-icon>
                    <span class="font-weight-bold mr-2">Phone Mapped:</span>
                    <div>
                      <span class="text-h6">{{ user.phoneMapped || "—" }}</span>
                    </div>
                    <v-btn
                      v-if="user.phoneMapped"
                      small
                      color="success"
                      dark
                      flat
                      class="ml-0"
                      @click="editPhone()"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </v-list-tile>

                  <v-divider></v-divider>

                  <!-- Extension -->
                  <v-list-tile class="px-0">
                    <v-icon color="blue-grey" class="mr-4">mdi-phone</v-icon>
                    <span class="font-weight-bold mr-2">Extension:</span>
                    <div v-if="!editExtension">
                      <span class="text-h6">{{ user.extension || "—" }}</span>
                    </div>

                    <v-btn
                      v-if="user.extension && !editExtension"
                      small
                      color="success"
                      dark
                      flat
                      class="ml-0"
                      @click="editExtension = true"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>

                    <div v-else class="d-flex align-center ml-4">
                      <v-text-field
                        type="text"
                        :rules="[rules.extension]"
                      ></v-text-field>
                      <v-btn
                        small
                        color="success"
                        dark
                        flat
                        class="ml-0"
                        @click="editExtension = true"
                      >
                        <v-icon small>mdi-check</v-icon>
                      </v-btn>
                    </div>
                    <!--  -->
                  </v-list-tile>

                  <v-divider></v-divider>

                  <!-- Site Name -->
                  <v-list-tile class="px-0">
                    <v-icon color="blue-grey" class="mr-4"
                      >mdi-office-building</v-icon
                    >
                    <span class="font-weight-bold mr-2">Site Name:</span>
                    <div>
                      <span class="text-h6">{{ user.siteName || "—" }}</span>
                    </div>
                  </v-list-tile>

                  <v-divider></v-divider>
                </v-list>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pb-3 pt-0">
            <v-spacer></v-spacer>
            <v-btn
              color="default"
              small
              @click="closeDialog"
              :dark="true"
              :disabled="false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      user: this.initialData.user || null,
      editExtension: false,
      editPhone: false,
      rules: {
        required: (value) => !!value || "Required.",
        extension: (v) => /^\d{5}$/.test(v) || "Enter a valid extension",
        phone: (v) =>
          /^\d{10}$/.test(v) ||
          "Enter a valid phone without dashes or parentheses",
      },
    };
  },

  created() {
    //console.log("User data:", this.user);
  },

  methods: {
    closeDialog() {
      this.$emit("closeUserDialog");
    },
  },
};
</script>

<style scoped>
.v-card-title {
  word-break: break-word;
}
</style>
